import React, { useState, useEffect, Fragment } from "react";
import { Row, Card, CardBody, Col } from "reactstrap";
import BreadcrumbLink from "../../../components/Common/BreadcrumbLink";
import i18n from "../../../i18n";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Instructions from "./Instructions";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import AlertError from "../../../components/Alerts/AlertError";
import { orgId } from "../../../constants/utils";

const CreateUser = (props) => {
  document.title = `${i18n.t("UserCreate")} - ${orgId}`;

  const dispatch = useDispatch()
  const [step, setStep] = useState(1);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [lastName, setLastName] = useState("");
  const [secondLastName, setSecondLastName] = useState("");
  const [company, setCompany] = useState("");
  const [isRole, setIsRole] = useState("ADMIN");
  const [infoUser, setInfoUser] = useState({ is_staff: false, permissions: [] })
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data
    })
  );

  const { token, data, loading } = useSelector(LoginProperties);

  useEffect(() => {
    if(data?.data){
      setInfoUser(data.data)
    }
  }, [dispatch, data, loading]);

  const switchStep = () => {
    switch(step){
      case 1:
        return <Step1
          setStep={setStep}
          step={step}
          setName={setName}
          setPhone={setPhone}
          setEmail={setEmail}
          name={name}
          phone={phone}
          email={email}
          token={token}
          lastName={lastName}
          secondLastName={secondLastName}
          company={company}
          isRole={isRole}
          setLastName={setLastName}
          setSecondLastName={setSecondLastName}
          setCompany={setCompany}
          setIsRole={setIsRole}
          infoUser={infoUser}
          setInfoUser={setInfoUser}
        />
        break;
      case 2:
        return <Step2
          token={token}
          step={step}
          setStep={setStep}
          name={name}
          phone={phone}
          email={email}
          lastName={lastName}
          secondLastName={secondLastName}
          company={company}
          isRole={isRole}
          infoUser={infoUser}
          setInfoUser={setInfoUser}
          setErrorAlert={setErrorAlert}
          setErrorAlertMessage={setErrorAlertMessage}
        />
      default:
        break;
    }
  }

  return (
    <Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <BreadcrumbLink
            title={i18n.t("Users")}
            link='/users'
            breadcrumbItem={i18n.t("UserCreate")}
          />
          <Row className="mb-0 pb-0">
            <Card>
              <CardBody>
                <Instructions step={step}></Instructions>
              </CardBody>
            </Card>
          </Row>
          <Col xxl={12} md={12} xs={12} className="">
            <AlertError
              showAlertError={errorAlert}
              setShowAlertError={setErrorAlert}
              textHeader={i18n.t("Error")}
              textBody={errorAlertMessage}
            />
          </Col>
          <div className="container-fluid">
            <Row>
              <Card>{switchStep()}</Card>
            </Row>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default CreateUser;
